import styled from '@emotion/styled';
import { Flex, theme, Tooltip, Typography } from 'antd';
import React, { type ReactNode, useMemo } from 'react';

interface OverflowComponentProps {
  elementsList: ReactNode[];
  stack?: boolean;
  maxCount?: number;
  layout?: 'horizontal' | 'vertical';
}

const StyledFlex = styled(Flex, {
  shouldForwardProp: (prop) => !['itemsMargin'].includes(prop),
})<{ itemsMargin: number }>`
  & > *:not(#overflow-more-text) {
    margin-inline-start: ${({ itemsMargin }) => itemsMargin}px;
  }
`;

export const OverflowComponent = (props: OverflowComponentProps): ReactNode => {
  const { token } = theme.useToken();
  const { elementsList, stack = false, maxCount = 7, layout = 'horizontal' } = props;

  const isHorizontal = useMemo(() => layout === 'horizontal', [layout]);

  return (
    <StyledFlex
      itemsMargin={stack ? -20 : 0}
      wrap={isHorizontal ? 'wrap' : undefined}
      style={{
        rowGap: isHorizontal ? token.marginXS : undefined,
        columnGap: !isHorizontal ? token.marginXS : undefined,
      }}
      vertical={!isHorizontal}
      align="flex-start"
      justify="flex-start"
    >
      {elementsList.slice(0, maxCount)}
      {elementsList.length > maxCount ? (
        <Tooltip
          arrow={false}
          title={
            <StyledFlex
              itemsMargin={stack ? -20 : 0}
              wrap="wrap"
              style={{ rowGap: token.marginXXS }}
            >
              {elementsList.slice(maxCount)}
            </StyledFlex>
          }
        >
          <Typography.Text id="overflow-more-text">
            +{elementsList.length - maxCount} more
          </Typography.Text>
        </Tooltip>
      ) : (
        ''
      )}
    </StyledFlex>
  );
};
